export default __webpack_public_path__ + "static/media/new-hover.22e3272c.svg";